// found in an experimental way
export const SENTRY_TAG_NAME_LIMIT = 30;
// from https://github.com/getsentry/sentry/issues/6576
export const SENTRY_TAG_VALUE_LIMIT = 200;
export const UNKNOWN_COMPONENT = 'unknown';
export const TAG_WARNING_LIMIT = 20;
//# sourceMappingURL=constants.js.map